/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';
import { TagApiRespModel } from '../../models/tag-api-resp-model';

export interface ApiMasterTagAddPost$Params {
      body?: Tag
}

export function apiMasterTagAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterTagAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TagApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTagAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagApiRespModel>;
    })
  );
}

apiMasterTagAddPost.PATH = '/api/Master/Tag/Add';
